import { api } from "./client.js";
import type { DeadLetterEntry, DeadLetterListResponse } from "@cas/shared";

export const deadletterApi = {
  list:    (status?: string) => api.get<DeadLetterListResponse>(`manage/deadletter${status ? `?status=${status}` : ""}`).then(r => r.entries),
  retry:   (messageId: string) => api.post<void>(`manage/deadletter/${messageId}/retry`),
  abandon: (messageId: string) => api.post<void>(`manage/deadletter/${messageId}/abandon`),
};
